
import React, { useContext, useState } from 'react';
import { UserContext } from '.';
import { useHistory } from "react-router-dom";
import styled, { css } from 'styled-components';
import Dialog from '@material-ui/core/Dialog';
import List from '@material-ui/core/List';
import DialogTitle from "@material-ui/core/DialogTitle";
import ListItem from '@material-ui/core/ListItem';

const StyledToolbarSwitchDepartment = styled.div`
  margin-top: 5px;
`;

const LinkSpan = styled.span`
  cursor: pointer;
  color: #828282;
  font-size: 12px;
  
  ${(props) => props.pointer && css`
    cursor: pointer;
  `}
`;

export default function ToolbarSwitchDepartment() {
  const userContext = useContext(UserContext);
  const { data, actions } = userContext;
  const [open, setOpen] = useState(false);
  const moreTheOneDepartment = data.departments.length > 1;
  const history = useHistory();

  const switchDepartment = (department) => {
    if (department.id !== data.department_active.id) {
        actions.patch({department_active: department.id, resourcetype: data.resourcetype}, (data) => {
          setOpen(false);
          history.push('/refresh');
        });
    }
    else {
      setOpen(false);
    }
  }

  return (
    <>
      <StyledToolbarSwitchDepartment>
        {moreTheOneDepartment && (
          <>
            <Dialog open={open} onClose={() => setOpen(false)}>
              <DialogTitle id="simple-dialog-title">Выберите филиал</DialogTitle>
              <List>
                {data.departments.map(department =>
                  <ListItem
                    selected={department.id === data.department_active.id}
                    button
                    key={department.id}
                    onClick={() => switchDepartment(department)}
                  >
                    {department.name}
                  </ListItem>
                )}
              </List>
            </Dialog>
            <LinkSpan onClick={() => setOpen(true)} pointer>{data.department_active.name}</LinkSpan>
          </>
        )}
        {!moreTheOneDepartment && (
          <LinkSpan>{data.department_active.name}</LinkSpan>
        )}
      </StyledToolbarSwitchDepartment>
    </>
  )
}